module.exports = "/_next/static/images/1-1-dbfa2c17117acd8ea1866229c334ed84.svg";